import { render } from "./quant.vue?vue&type=template&id=816d3fbc&scoped=true&ts=true"
import script from "./quant.vue?vue&type=script&lang=ts"
export * from "./quant.vue?vue&type=script&lang=ts"

import "./quant.vue?vue&type=style&index=0&id=816d3fbc&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-816d3fbc"]])

export default __exports__